import { useActiveBookingContext, useBookingEngineStateContext, usePropertyContext } from "@app/app/hooks";
import { IBookingEngineState } from "@app/app/types";
import { useFormContext } from "react-hook-form";

import { BookableType, IFilter, IFilterGroup, TFilter } from "../types";
import { FilterModalComponent } from "./FilterModalComponent";

export interface IFilterModalProps {
    triggerButtonClassName?: string;
}

export const RoomFilterModal = ({ triggerButtonClassName }: IFilterModalProps) => {
    const { activeProperty } = usePropertyContext();
    const { getState, availability } = useBookingEngineStateContext();
    const { activeBookingIndex } = useActiveBookingContext();
    const { setValue } = useFormContext<IBookingEngineState>();
    const rooms = availability[activeBookingIndex]?.rooms || [];
    const filterState = getState()?.bookableItemsFilter || { filters: [] };
    const filters = filterState.filters.reduce((obj: any, el: string) => ({ ...obj, [el]: true }), {});

    const activeFilter = (f: IFilter, i: number, a: IFilter[]) => rooms.some((r) => r.filters.includes(f.id));

    const filterGroups = (activeProperty?.filter_groups || []).map((g) => ({ ...g, filters: g.filters.filter(activeFilter) }));

    const showFilterButton = filterGroups.filter((g) => !!g.filters.length).length > 0;

    const preSubmit = (formFilters: TFilter) => {
        const filterIds = Object.keys(formFilters).filter((id) => !!formFilters[id]);
        setValue("bookableItemsFilter", { type: BookableType.Room, filters: filterIds });
    };

    return showFilterButton ? (
        <FilterModalComponent
            key={`booking-filter-modal-${activeProperty?.id}`} // force a reset when changing property
            filterGroups={filterGroups}
            defaultFilters={filters}
            onSubmit={preSubmit}
            triggerButtonClassName={triggerButtonClassName}
        />
    ) : null;
};
